import { Component } from '@angular/core';
import { PATH_FORGOT_PASSWORD } from '../login.global';
import { LoginCardComponent } from '../../calvin-emr-shared/login/login-card/login-card.component';

@Component({
  selector: 'app-login-page',
  template: `
    <div class="wrapper">
      <div class="card-container">
        <app-login-card [forgotPasswordPath]="forgotPasswordPath"></app-login-card>
      </div>
    </div>
  `,
  styles: [`
    .wrapper {
      justify-content: center;
    }
    .card-container {
      margin-top: 10vh;
    }
  `],
  standalone: true,
  imports: [LoginCardComponent],
})
export class LoginPageComponent {
  forgotPasswordPath = '/' + PATH_FORGOT_PASSWORD;
}
